<template>
  <div>
    <a-spin :spinning="loading">
      <a-tabs defaultActiveKey="1" size="large">
        <a-tab-pane key="1">
            <span slot="tab">
              <a-icon type="stop"/>
              Retención en la fuente
            </span>
          <a-form-model layout="vertical" :model="infoCompleteRetefte" :rules="formRules"
                        @submit.native.prevent @submit="guardarDatosPersonales"
                        ref="datos_retefuente">
            <a-card>
              <a-tabs defaultActiveKey="1"
                      size="small"
              >
                <a-tab-pane key="1">
                <span slot="tab">
                  <a-icon type="stop"/>
                  Retención en la fuente
                </span>
                  <a-card>
                    <a-row :gutter="[16,16]" :md="12" :xs="24">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Procedimiento ReteFte')" prop="rte_procedimiento" has-feedback>
                          <a-input style="width: 100%"
                                   v-model="infoCompleteRetefte.rte_procedimiento"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('% R. en fuente')" prop="rte_porcentaje" has-feedback>
                          <a-input style="width: 100%"
                                   v-model="infoCompleteRetefte.rte_porcentaje"></a-input>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Prom. salud')" prop="prm_salud" has-feedback>
                          <a-input-number style="width: 100%" step="1"
                                          v-model=infoCompleteRetefte.prm_salud>
                          </a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha inicial')" prop="start_date">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Incial"
                                         v-model="infoCompleteRetefte.start_date"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha final')" prop="end_date">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Final"
                                         v-model="infoCompleteRetefte.end_date"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
                <a-tab-pane key="2">
                <span slot="tab">
                  <a-icon type="heart"/>
                  Deducible
                </span>
                  <a-card>
                    <h3 style="text-align: center;font-weight: bold;">Deducible de salud</h3>
                    <a-row :gutter="[16,16]" :md="12" :xs="12">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Deducible salud')" prop="ded_salud" has-feedback>
                          <a-input-number style="width: 100%" step="1"
                                          v-model=infoCompleteRetefte.ded_salud>
                          </a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Deducible salud anual')" prop="ded_sal_anual" has-feedback>
                          <a-input-number style="width: 100%" step="1"
                                          v-model=infoCompleteRetefte.ded_sal_anual>
                          </a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha inicial')" prop="start_date_sal">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Inicial"
                                         v-model="infoCompleteRetefte.start_date_sal"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha final')" prop="end_date_sal">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Final"
                                         v-model="infoCompleteRetefte.end_date_sal"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                    <a-divider>
                      <div style="text-align: center;font-weight: bold;">Deducible de vivienda</div>
                    </a-divider>
                    <a-row :gutter="[16,16]" :md="12" :xs="12">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Deducible de vivienda')" prop="ded_vivienda" has-feedback>
                          <a-input-number style="width: 100%" step="1"
                                          v-model=infoCompleteRetefte.ded_vivienda>
                          </a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Deducible de vivienda anual')" prop="ded_viv_anual" has-feedback>
                          <a-input-number style="width: 100%" step="1"
                                          v-model=infoCompleteRetefte.ded_viv_anual>
                          </a-input-number>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha inicial')" prop="start_date_viv">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Inicial"
                                         v-model="infoCompleteRetefte.start_date_viv"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha final')" prop="start_date_viv">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Inicial"
                                         v-model="infoCompleteRetefte.end_date_viv"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>

                <a-tab-pane key="4">
                <span slot="tab">
                  <a-icon type="calendar"/>
                  Dependientes y declarante
                </span>
                  <a-card>
                    <a-row :gutter="[16,16]" :md="12" :xs="24">
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Deducción dependiente')" prop="ded_dependiente"
                                           :has-feedback="false">
                          <a-checkbox v-model="infoCompleteRetefte.ded_dependiente" @change="validarCampoDeduDependiente"/>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha inicial dependiente')" prop="start_date_dep">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Inicial Dependiente"
                                         v-model="infoCompleteRetefte.start_date_dep"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha final dependiente')" prop="end_date_dep">
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Inicial Dependiente"
                                         v-model="infoCompleteRetefte.end_date_dep"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Declarante')" prop="declarante" :has-feedback="false">
                          <a-checkbox v-model="infoCompleteRetefte.declarante" @change="validarCampoDeclarante">
                          </a-checkbox>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha inicial declarante')" prop="start_date_dec" has-feedback>
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Inicial Declarante"
                                         v-model="infoCompleteRetefte.start_date_dec"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Fecha final declarante')" prop="end_date_dec" has-feedback>
                          <a-date-picker style="width: 100%"
                                         placeholder="Fecha Final Declarante"
                                         v-model="infoCompleteRetefte.end_date_dec"
                                         valueFormat="Y-MM-DD HH:mm:ss"
                          ></a-date-picker>
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Creado por')" prop="created_by" has-feedback>
                          {{infoCompleteRetefte.created_by}}
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Creado')" prop="created_on" has-feedback>
                          {{infoCompleteRetefte.created_on}}
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Modificado por')" prop="modified_by" has-feedback>
                          {{infoCompleteRetefte.modified_by}}
                        </a-form-model-item>
                      </a-col>
                      <a-col v-bind="colSpan">
                        <a-form-model-item :label="$t('Modificado')" prop="modified_on" has-feedback>
                          {{infoCompleteRetefte.modified_on}}
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>
            </a-card>
            <a-affix :offset-bottom="10">
              <a-card style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
                <a-button v-if="!$userIsInrol('Query')"
                          type="primary"
                          html-type="submit">
                  Guardar Cambios
                </a-button>
              </a-card>
            </a-affix>
          </a-form-model>
        </a-tab-pane>
        <a-tab-pane key="2">
            <span slot="tab">
              <a-icon type="clock-circle"/>
              Histórico
            </span>
          <a-card>
            <employee-retefte-hist ref="historial" :empleadoseleccionado="empleadoseleccionado"></employee-retefte-hist>
          </a-card>
        </a-tab-pane>
        <a-tab-pane key="3">
            <span slot="tab">
              <a-icon type="team"/>
              Dependientes 2276
            </span>
          <a-card>
            <employee-deduccion-dependiente :id_emp="empleadoseleccionado"/>
          </a-card>
        </a-tab-pane>
      </a-tabs>
<!--
      <a-modal title="Dependientes"
               width="90%"
               :visible="modal.visible"
               @ok="confirmar"
               :confirmLoading="modal.loading"
               :cancel-button-props="{props: { disabled: true } }"
               :closable="false"
               :maskClosable="false">
        <employee-deduccion-dependiente v-if="this.empleadoseleccionado" :id_emp="this.empleadoseleccionado"/>
        <br/>
        <div>
          <a-alert type="error" :message="confirmarModal.mensajeError" v-if="confirmarModal.error" :closable="true" show-icon/>
          <br/>
        </div>
      </a-modal>
-->
    </a-spin>
  </div>
</template>
<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['empleadoseleccionado'],
    mounted () {
      this.httpClient = new HttpUtil()
      this.consultarRtefte()
      this.initFormRules()
    },
    data () {
      return {
        modal: {
          visible: false,
          loading: false
        },
        confirmarModal: {
          mensajeError: '',
          error: false
        },
        isRequiredFechasDeduDependiente: null,
        isRequiredFechasDeclarante: null,
        habilitarProcedimiento: false,
        isDeleteVisible: false,
        isTabDependientesVisible: false,
        loading: false,
        infoCompleteRetefte: {},
        formRules: {},
        colSpan: {
          xs: 24,
          md: 8
        }
      }
    },
    methods: {
      guardarDatosPersonales () {
        if (this.loading) return
        this.$refs.datos_retefuente.validate(valid => {
          if (valid) {
            this.loading = true
            let req = {...this.infoCompleteRetefte, id_emp: this.empleadoseleccionado}
            this.httpClient.getInstance().post('employee/guardar_datos_retefuente', req)
              .then(() => {
                this.isTabDependientesVisible = req.ded_dependiente
                Mensajes.success('Correcto', 'Datos guardados correctamente')
              })
              .catch(() => {
                Mensajes.error('Error', 'No fue posible guardar la información, contacte al administrador.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      consultarRtefte () {
        this.loading = true
        let self = this
        this.httpClient.getInstance().get('employee/consultar_retefuente/' + this.empleadoseleccionado)
          .then(response => {
            self.infoCompleteRetefte = response.data
            this.isRequiredFechasDeduDependiente = response.data.ded_dependiente
            this.isRequiredFechasDeclarante = response.data.declarante
            this.initFormRules()
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos')
          })
          .then(() => {
            this.selectedRowKeys = []
            this.loading = false
          })
      },
      initFormRules () {
        this.formRules = {
          rte_procedimiento: [{required: true, message: 'Valor requerido'}],
          rte_porcentaje: [{required: false}],
          prm_salud: [{required: false}],
          start_date: [{required: false}],
          end_date: [{required: false}],
          ded_salud: [{required: false}],
          ded_sal_anual: [{required: false}],
          start_date_sal: [{
            required: this.$getConfigValue('RTE_REQUERIDO_FECHAS_DEDU_SALUD', 'SI') === 'SI',
            message: 'Valor requerido'
          }],
          end_date_sal: [{
            required: this.$getConfigValue('RTE_REQUERIDO_FECHAS_DEDU_SALUD', 'SI') === 'SI',
            message: 'Valor requerido'
          }],
          declarante: [{required: false}],
          start_date_dec: [{required: this.isRequiredFechasDeclarante, message: 'Valor requerido'}],
          end_date_dec: [{required: this.isRequiredFechasDeclarante, message: 'Valor requerido'}],
          ded_vivienda: [{required: false}],
          ded_viv_anual: [{required: false}],
          start_date_viv: [{
            required: this.$getConfigValue('RTE_REQUERIDO_FECHAS_DEDU_VIVIENDA', 'SI') === 'SI',
            message: 'Valor requerido'
          }],
          ded_dependiente: [{required: false}],
          start_date_dep: [{required: this.isRequiredFechasDeduDependiente, message: 'Valor requerido'}],
          end_date_dep: [{required: this.isRequiredFechasDeduDependiente, message: 'Valor requerido'}],
          end_date_viv: [{
            required: this.$getConfigValue('RTE_REQUERIDO_FECHAS_DEDU_VIVIENDA', 'SI') === 'SI',
            message: 'Valor requerido'
          }]
        }
      },
      validarCampoDeduDependiente () {
        if (!JsUtils.isEmpty(this.infoCompleteRetefte.ded_dependiente)) {
          this.isRequiredFechasDeduDependiente = this.infoCompleteRetefte.ded_dependiente
          this.initFormRules()
        }
      },
      validarCampoDeclarante () {
        if (!JsUtils.isEmpty(this.infoCompleteRetefte.declarante)) {
          this.isRequiredFechasDeclarante = this.infoCompleteRetefte.declarante
          this.initFormRules()
        }
      },
      confirmar () {
        this.modal.loading = true
        this.httpClient.getInstance().post('consultar_dependientes', { id_emp: this.empleadoseleccionado })
          .then(response => {
            if (response.data.message === true) {
              this.$emit('loadData')
              this.modal.loading = false
              this.modal.visible = false
            } else {
              this.confirmarModal.error = true
              this.confirmarModal.mensajeError = response.data.message
            }
          })
          .catch(() => {
            this.modal.loading = false
            Mensajes.error('Error', 'No fue posible consultar los datos')
          })
          .then(() => {
            this.modal.loading = false
          })
      }
    },
    watch: {
      empleadoseleccionado () {
        this.consultarRtefte()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeRetefte.vue